<template>
<v-container class="py-0">
  <v-row wrap align="center" justify="center">
    <v-col v-for="(lob, idx) in policy.linesOfBusiness" :key="idx" cols="12" class="py-1">
      <v-card color="blue5" @click="doNavigation(lob.code)">
        <v-card-title>{{ lobCodes[lob.code] }}</v-card-title>
        <v-card-subtitle>{{ lob.form }}</v-card-subtitle>
      </v-card>
    </v-col>
  </v-row>
</v-container>
</template>

<style>
</style>

<script>
import lobCodeService from '@/services/clientViewer/lobCodeService.js';
import analyticsService from '@/services/shared/analyticsService.js';

export default {
  name: 'Policies',
  props: {
    policy: {
      type: Object,
      default: null
    }
  },
  data: function () {
    return {
      viewingMore: false
    };
  },
  computed: {
    environment () {
      return localStorage.getItem('environment');
    },
    clientId: function () {
      return this.$route.params.clientId;
    },
    policyOrderNumber: function () {
      return this.$route.params.policyOrderNumber;
    },
    isPackage: function () {
      if ((this.policy || null) === null || (this.policy.linesOfBusiness || null) === null) {
        return false;
      }

      return this.policy.linesOfBusiness.length > 1;
    },
    lobCodes: function () {
      return lobCodeService.lobCodes;
    }
  },
  methods: {
    getLineOfBusinessColor: function (idx) {
      // Fun little surprise for Product Owners
      if (this.environment === 'PO') {
        var letters = '0123456789ABCDEF';
        var color = '#';
        for (var i = 0; i < 6; i++) {
          color += letters[Math.floor(Math.random() * 16)];
        }

        return color;
      } else return 'blue5';
    },
    doNavigation (lobCode) {
      if ((this.policy || null) === null) return;
      analyticsService.sendEvent(this.$gtag, 'Button Click', 'Policy', 'Select LoB');
      var newPath = `${this.$route.path}/lob/${lobCode}`;
      this.$router.push(newPath);
    }
  }
};
</script>
